<script>
    import { Line } from 'vue-chartjs'

    export default {
        extends: Line,
        props: {
            chartdata: Array,
            options: Array,
            unit: String,
            dataname: String,
            linecolor: String,
            pointcolor: String,
            chartOptions: {
                default: () => ({
                    lineTension: 0.4,
                    showAllTooltips: false
                })
            },
            displayLabels: Boolean
        },
        mounted () {
            Chart.defaults.global.legend.display = false
            Chart.defaults.global.defaultFontFamily = 'Kanit, sans-serif'

            this.renderChart({
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: 'transparent',
                        pointBackgroundColor: this.pointcolor == null ? '#FF5100':this.pointcolor,
                        borderColor: this.linecolor == null ? '#507CD6':this.linecolor,
                        lineTension: this.chartOptions.lineTension,
                        borderWidth: 5,
                        tooltipEvents: [],
                        data: this.options,
                        // Change options only for labels of THIS DATASET
                        datalabels: {
                            display: !!this.displayLabels,
                            formatter: function (value, context) {
                                if (Number(value) === value && value % 1 !== 0) {
                                    return value.toFixed(2);
                                }
                                return value;
                            }
                        },
                    }
                ],
            },
            {
                responsive: true,
                maintainAspectRatio: false,

                // Working.
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                hover: {
                    mode: 'index',
                    intersect: false
                },

                showAllTooltips: this.chartOptions.showAllTooltips
            })
        }
    }
</script>

<style scoped>



</style>
